var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-button',{staticClass:"float-right",attrs:{"sync":"","disabled":_vm.isDisabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }